import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MessageBar as FluentMessageBar } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomRendering } from './custom-component';

const MessageBar = (props) => {
  const i18n = useContext(I18nContext);
  const { text, ...rest } = props;
  return <FluentMessageBar {...rest}>{i18n.getString(text)}</FluentMessageBar>;
};

MessageBar.propTypes = {
  Renderer: PropTypes.elementType,
  rendererProps: PropTypes.shape({}),
  text: PropTypes.string,
};

MessageBar.defaultProps = {
  Renderer: null,
  rendererProps: null,
  text: null,
};

const MessageBarWrapped = withCustomRendering(MessageBar);

export { MessageBarWrapped as MessageBar };
